<template>
  <div class="typeform-button">
    <button class="btn--small" :class="{ active: active }" @click="$emit('clicked')">
      <span v-if="iconDirection === 'left'" class="tag-icon__left" :class="classIcon" />
      {{ content }}
      <span v-if="iconDirection === 'right'" class="tag-icon__right" :class="classIcon" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'TypeFormButton',
  props: {
    content: {
      type: String,
      default: '',
      require: true,
    },
    icon: {
      type: String,
      default: '',
    },
    iconDirection: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classIcon() {
      return [ { active: this.active }, this.icon ];
    },
  },
};
</script>
